import { BUSINESS_PURPOSE, COMPANY_SIZE } from '../../types';
import { isFromSellerCountry } from './isFromSellerCountry';

interface ShouldShowCardParams {
    companySize: COMPANY_SIZE | string | undefined | null;
    purposes: BUSINESS_PURPOSE[] | string[] | null | undefined;
    avgOrderAmount: number | null | undefined;
    countryCode: string;
}

export const shouldShowCard = ({
    companySize,
    purposes,
    avgOrderAmount,
    countryCode,
}: ShouldShowCardParams): boolean => {
    if (isFromSellerCountry(countryCode)) {
        return false;
    }

    if (companySize && companySize !== COMPANY_SIZE.ONLY_ME) {
        return true;
    }

    if (purposes?.length && purposes.includes('business')) {
        return true;
    }

    if (avgOrderAmount && avgOrderAmount >= 10000) {
        return true;
    }

    return false;
};
